<div class="neet-live-class-wrapper">
    <mat-dialog-content class="neet-live-class-box" (keyup)="keyEscape($event)">
        <div class="content">
            <div class="nlc-box">
                <div class="ncl-lft" style="background-image: url('assets/img/neet-left-img.png')"></div>
                <div class="ncl-rht">
                    <button class="closeButton" (click)="closeModal()"></button>
                    <h3>{{heading}}</h3>
                    <!--p>Register now for early bird discount.</p-->
                    <form #neetlive="ngForm" (ngSubmit)="next()">
                        <p class="p1">All fields are mandatory</p>
                        <div class="form-group"><span class="user-icon"></span>
                            <input type="text" placeholder="First Name" name="firstname" [(ngModel)]="neetForm.firstname"
                                required class="form-control input-name">
                        </div>
                        <div class="form-group"><span class="user-icon"></span>
                            <input type="text" placeholder="Last Name" name="lastname" [(ngModel)]="neetForm.lastname"
                                required class="form-control input-name">
                        </div>
                        <div class="form-group"><span class="email-icon"></span>
                            <input type="text" placeholder="Email" name="email" [(ngModel)]="neetForm.email" required
                                pattern="^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}$"
                                class="form-control input-name">
                            <span class="text-danger font-weight-bold"
                                *ngIf="neetlive.form.controls?.email?.errors?.pattern">*Please Enter Valid
                                E-mail
                                address</span>
                        </div>
                        <div class="form-group"><span class="phone-icon"></span><span class="code">+ 91</span><input
                                type="number" maxlength="10" minlength="10" name="phone"
                                (keydown)="limitnumbertoten($event)" placeholder="Mobile Number" required
                                pattern="^[6-9][0-9]{9}$" [(ngModel)]="neetForm.phone"
                                class="form-control input-tel ">
                            <span class="text-danger font-weight-bold"
                                *ngIf="neetlive.form.controls?.phone?.touched && neetlive.form.controls?.phone?.errors?.pattern">*Please
                                Enter Valid Mobile Number</span>
                        </div>
                        <div class="grade-select">
                            <p class="p2">Select your grade</p>
                            <div class="grades">
                                <button type="button" [ngClass]="{'active':neetForm.grade==11}"
                                    (click)="selectGrade(11)" class="btn">11th</button>
                                <button type="button" [ngClass]="{'active':neetForm.grade==12}"
                                    (click)="selectGrade(12)" class="btn">12th</button>
                            </div>
                        </div>
                        <div class="custom-control custom-checkbox text-center">
                            <label class="UNFAPP-whtapp-chkarea" for="customCheck1">
                                <input type="checkbox" class="custom-control-input" id="customCheck1" name="whatsappConsent"
                                    [(ngModel)]="neetForm.whatsappConsent">
                                <span class="_custom-control-label whtschkcnt">Receive updates on Whatsapp</span>
                            </label>
                        </div>
                        <div class="d-flex justify-content-center assessment_mt-20">
                            <button type="button" class="btn btn-dark" [disabled]="neetlive?.invalid || !neetForm.grade"
                                (click)="next()">REGISTER</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</div>